// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/frontend/app.scss
// module id = 392
// module chunks = 22